import { Id, IMetadata } from '@/shared/types/builtInTypes'

/**
 * Notification trigger types and interfaces.
 * These types are used to define the structure of notification triggers
 */
export interface INotificationTrigger<T = IChannel> extends IMetadata {
  id: Id
  name: string
  status: TriggerStatus
  channels: T[]
  channelIds?: Id[]
  variables: string[]
  linkTo?: string
  description?: string
  notes?: string
}

export interface IStatusTracking extends IMetadata {
  id: Id
  status: TriggerStatus
  note: string
}

export interface IStatusTracking extends IMetadata {
  id: Id
  status: TriggerStatus
  note: string
}

export interface IStatusTracking extends IMetadata {
  id: Id
  status: TriggerStatus
  note: string
}

// Enum for trigger statuses
export enum TriggerStatus {
  RUNNING = 'running',
  PAUSED = 'paused'
}

// Channel type discriminator
export type ChannelType = 'SMS' | 'Email' | 'InApp' | 'Push' | 'WhatsApp'

export interface BaseChannel {
  id: Id
  name: ChannelType // This is the discriminator property (channel type)
}

export interface SMSChannel extends BaseChannel {
  name: 'SMS'
  content: MultiLang<string>
}

export interface EmailChannel extends BaseChannel {
  name: 'Email'
  subject: MultiLang<string>
  body: MultiLang<string>
}

export interface InAppChannel extends BaseChannel {
  name: 'InApp'
  subject: MultiLang<string>
  body: MultiLang<string>
}

export interface PushChannel extends BaseChannel {
  name: 'Push'
  subject: MultiLang<string>
  body: MultiLang<string>
  imgUrl?: string
}

export interface WhatsAppChannel extends BaseChannel {
  name: 'WhatsApp'
  content: MultiLang<string>
  error?: MultiLang<string>
  whatsappStatus?: WhatsAppStatus
}

// Discriminated union type
export type IChannel =
  | SMSChannel
  | EmailChannel
  | InAppChannel
  | PushChannel
  | WhatsAppChannel

export type MultiLang<T> = {
  en: T
  ckb: T
  ar: T
  [key: string]: T
}

export const triggerStatusColors: Record<TriggerStatus, string> = {
  [TriggerStatus.RUNNING]: 'success',
  [TriggerStatus.PAUSED]: 'warning'
}

export enum WhatsAppStatus {
  PENDING = 'pending',
  REJECTED = 'rejected',
  APPROVED = 'approved'
}

export const whatsAppStatusColors: Record<WhatsAppStatus, string> = {
  [WhatsAppStatus.PENDING]: 'info',
  [WhatsAppStatus.REJECTED]: 'error',
  [WhatsAppStatus.APPROVED]: 'success'
}

// Types for better type safety
export interface SuggestionState {
  field: string
  lang: string
  cursorPosition: number
}

export interface LanguageConfig {
  code: string
  label: string
}

// Constants moved outside class for better performance
export const languageConfig: readonly LanguageConfig[] = Object.freeze([
  { code: 'en', label: 'En' },
  { code: 'ckb', label: 'Ckb' },
  { code: 'ar', label: 'Ar' }
])

export const rtlLanguages = new Set(['ar', 'ckb'])

export const debounceDelays = {
  VALIDATE: 800,
  EMIT_CHANGE: 1200
} as const

export const keyboardKeys = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: 'Space'
} as const
